// extracted by mini-css-extract-plugin
export var userActivityLockedLabel = "user-activity-locked-label_C_8YPCWo9Uhn38mzBMG2";